import React, { useState, useEffect} from "react";

import "./styles.css";

/**
 * @function UIToggle
 * @param {STRING} dataPoint - Sets the datapoint of the toggle.
 * @param {STRING} text - Sets the label text of the toggle.
 * @param {STRING} className - Allows us to set a unique className for the toggle.
 * @returns {React.Component}
 * @exported true
 * @description This is a toggle that allows the user to toggle something on or off. Will mainly be used to turn on and off the biller groups on the PayBillsPage.
 * @example 
 * <UIToggle dataPoint="toggle_data_point" text="Toggle Label" />
 */
export default function UIToggle(props) {
  const dataPoint = props.dataPoint ? {"data-point":props.dataPoint}:{};
  const text = props.text ?? "[toggle label]";
  const className = props.className ?? "";
  const [ getToggle, setToggle ] = useState(props.checked ?? false);

  const onChange = () => {
    if(props.disabledPrompt !== true) {
      if(props.onChange instanceof Function) {
        props.onChange(!getToggle);
      }

      setToggle(!getToggle);
    }
  }

  useEffect(() => setToggle(props.checked ?? false), [ props.checked ]);

  return(
    <div className={ "ui-toggle " + className } { ...dataPoint }>
      <label className="toggle-switch">
        <input className="toggle-checkbox" type="checkbox" checked={ getToggle } onChange={ onChange } />
        <div className="toggle-background" />
        <div className="toggle-switch-indicator" />
        <span className="toggle-text" />
        <span className="toggle-label">{ text }</span>
      </label>
    </div>
  );
}